import { account, socialLogin } from '@silvertours/front-entities';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export type LoginProps = {
  error: account.LoginError | null;
  isLoggedIn: boolean;
  setError: Dispatch<SetStateAction<account.LoginError | null>>;
  setIsLoggedIn: Dispatch<SetStateAction<boolean>>;
  setShowLogin: (show: boolean) => void;
  setShowMobileLogin: (show: boolean) => void;
  setUsername: Dispatch<SetStateAction<string>>;
  showLogin: boolean;
  showMobileLogin: boolean;
  username: string;
  /* Social login. These stay inert while `isSocialLoginActive` is off. */
  /** The providers that the site settings fully configure. */
  availableProviders: Record<socialLogin.SocialLoginProvider, boolean>;
  /** The provider that runs now. Only its button shows the spinner. */
  pendingProvider: socialLogin.SocialLoginProvider | null;
  isSocialLoginProcessing: boolean;
  startSocialLogin: (provider: socialLogin.SocialLoginProvider) => void;
  /**
   * True while the gate shows the provider buttons. The modal drops its
   * sign-up footer on this step, and the form shows the buttons in place of
   * the email fields.
   */
  isProviderStep: boolean;
  /** Moves from the provider buttons to the email fields, and back. */
  setEmailChosen: (chosen: boolean) => void;
};

const LoginContext = createContext<LoginProps | null>(null);

const useLogin = () => {
  const context = useContext(LoginContext);

  if (context === null) {
    throw new Error(
      'Ensure you have wrapped the login form in a LoginProvider',
    );
  }

  return context;
};

export { LoginContext, useLogin };
